Vue.asyncComponent('cms-active-workspace-logo', {
    props: {
        maxHeight: {
            type: String,
        },
        maxWidth: {
            type: String,
        }
    },
    computed: {
        logo() {
            return this.$userInterfaceHandler.getUserInterface()?.workspace.logo ?
                    this.$userInterfaceHandler.getUserInterface()?.workspace.logo:
                    this.$getSetting('assets.logo');
        },
        title() {
            return this.$userInterfaceHandler.getUserInterface()?.workspace.title ?
                    this.$userInterfaceHandler.getUserInterface()?.workspace.title:
                    null;
        }
    }
}, 'cms/layout/cms-active-workspace-logo.html');